import Button from "@/components/core/Button/Button"
import React, { useEffect, useState } from "react"
import Sticky from "react-sticky-el"
import styles from "./StickyButton.module.scss"
import useWindowResize from "@/hooks/useWindowResize"
const StickyButton = ({
  sticky,
  handleShowNavigator,
  isSubmitButtonDisabled,
  addressList = [],
  stickyShippingInfo,
  paymentSticky,
  handleSaveAddress,
  handleSubmit,
  shippingItems,
  errorAlert,
  i18n,
  stickyCheckout,
  checkoutLabel,
  handleCheckout,
  disableCheckout,
  checkoutFlag,
  isIscUser,
  inventoryCheckLoading,
  setPaymentSticky = () => {},
  setSticky,
  setStickyShippingInfo,
  isPanConsentRequired = () => {},
  curStep,
}) => {
  const [scrollUp, setScrollUp] = useState(false)
  const [showSticky, setShowSticky] = useState(true)
  let lastScrollY = 0

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setScrollUp(true)
      } else {
        setScrollUp(false)
      }
      lastScrollY = window.scrollY
    }
    window.addEventListener("scroll", handleScroll)
    if (sticky) setPaymentSticky(false)
    if (paymentSticky) {
      setSticky(false)
      setStickyShippingInfo(false)
    }
    const isPanRequired = isPanConsentRequired()
    if ((isPanRequired && curStep === 1) || (!isPanRequired && curStep === 1)) {
      setPaymentSticky(false)
      setShowSticky(false)
    }
  }, [])
  const [width] = useWindowResize()
  const [isMobile, setIsMobile] = useState(width <= 991)
  useEffect(() => {
    setIsMobile(width <= 991)
  }, [width])
  useEffect(() => {
    const isPanRequired = isPanConsentRequired()
    if ((isPanRequired && curStep === 1) || (!isPanRequired && curStep === 1)) {
      setPaymentSticky(false)
      setShowSticky(false)
    }
  }, [curStep])

  return (
    <div className={styles.checkoutPageWrapper}>
      <Sticky
        topOffset={0}
        className="checkoutPage__sticky-wrapper"
        stickyClassName={"sticky sticky-checkout-page"}
      >
        {isMobile && showSticky && (
          <div className="checkoutPage container-fluid">
            <div className="pdp-sticky-header__details-wrap container-fluid">
              <div className="pdp-sticky-header__container kf-react-plp-container">
                {sticky && (
                  <Button
                    role="button"
                    className={`checkoutPage__continueBtn`}
                    label={i18n.continuetoshipping}
                    flexible={true}
                    onClick={handleShowNavigator}
                    disabled={isSubmitButtonDisabled}
                    tabIndex={isSubmitButtonDisabled ? -1 : 0}
                    size="small"
                  />
                )}
                {stickyShippingInfo && addressList.length > 0 && (
                  <Button
                    role="button"
                    customClass="shipping-address__submitBtn"
                    disabled={addressList.length === 0}
                    label={i18n.continueToDelivery}
                    onClick={handleSaveAddress}
                  />
                )}
                {paymentSticky && (
                  <Button
                    customClass="checkoutPage__submit-button-sticky"
                    label={
                      inventoryCheckLoading
                        ? "Recalculating delivery"
                        : i18n.continueToPayment
                    }
                    role="button"
                    className="gbh-data-layer"
                    onClick={() => handleSaveAddress(null, true)}
                    disabled={
                      isIscUser
                        ? false
                        : !addressList.length ||
                          shippingItems?.length < 1 ||
                          errorAlert
                    }
                    loading={inventoryCheckLoading}
                    size="small"
                  />
                )}
                {stickyCheckout && checkoutFlag && (
                  <Button
                    //todo
                    // ariaLabel={i18n.continueCheckoutAria(
                    //   cartItems?.length,
                    //   `${currencySign}${estimatedTotal}`
                    // )}
                    // data-gbh-data-layer-custom={`{"cart":{"item":"n/a","price":"${subtotal}"}}`}
                    className={`gbh-data-layer checkout-btn-group-sticky checkoutScroll`}
                    label={checkoutLabel}
                    flexible
                    type="primary"
                    onClick={() => handleCheckout()}
                    role="button"
                    disabled={disableCheckout}
                    size="small"
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </Sticky>
    </div>
  )
}
export default StickyButton
